import React from 'react';

const Placeholder = () => (
  <div className="Placeholder">
    <h1>
      Under Construction
      <br />
      Coming Soon
    </h1>
  </div>
);

export default Placeholder;
